import { translate } from "app/filters/i18nFilter";
import {
    CURRENT_CRUMB,
    GENERAL_TAB_TITLE,
    NEWS_SETTINGS_TAB_TITLE,
    SUBSCRIPTIONS_TAB_TITLE,
} from "app/pages/activation/modules/Settings/text";
import type { DataToSaveSchema, SettingsConfigEntity } from "app/pages/activation/modules/Settings/types";
import { SettingsTabs } from "app/pages/activation/modules/Settings/types";
import { ACTIVATION_HOME_ROUTE, ACTIVATION_PROJECT_ROUTE } from "app/pages/activation/routing/constants";
import { HOMEPAGE_TEXT } from "app/pages/activation/services/constants";

export const TAB_DICTIONARY: SettingsConfigEntity = Object.seal({
    [SettingsTabs.General]: { id: SettingsTabs.General, title: GENERAL_TAB_TITLE },
    [SettingsTabs.Subscriptions]: { id: SettingsTabs.Subscriptions, title: SUBSCRIPTIONS_TAB_TITLE },
    [SettingsTabs.NewsSettings]: { id: SettingsTabs.NewsSettings, title: NEWS_SETTINGS_TAB_TITLE },
});

export const TABS_ARRAY = Object.keys(TAB_DICTIONARY) as SettingsTabs[];

export const getCrumbList = (name: string) => [
    {
        state: ACTIVATION_HOME_ROUTE,
        title: translate(HOMEPAGE_TEXT),
    },
    {
        state: ACTIVATION_PROJECT_ROUTE,
        title: name,
    },
    {
        state: "",
        title: translate(translate(CURRENT_CRUMB)),
    },
];

export const initialDataToSave: DataToSaveSchema = {
    selectedCountry: null,
    selectedWebsite: null,
    competitors: { competitors: [], mainCompetitors: [] },
    gaMapping: null,
    isGeneralSettingsChanged: false,
    trafficSource: null,
    activationSetName: null,
    nameError: { isError: false, errorMessage: "" },
    onSubscribe: () => null,
    onSaveNewsSettings: () => Promise.resolve(),
};
